import { useQuery } from '@tanstack/react-query';
import { partnersApi, PartnerQueueRow } from '../api/partners';

/**
 * The tenant's partner review queue (submitted-status rows awaiting staff
 * action). Query keys are shared with every caller — AdminLayout's nav
 * badge and PartnersSettings' full table both mount at once (AdminLayout
 * wraps every /settings/* page), so react-query dedupes the two fetches
 * into one request instead of racing them.
 */
export function usePartnerQueue() {
  const { data: form } = useQuery({
    queryKey: ['partner-form'],
    queryFn: partnersApi.getForm,
  });

  const { data: queue, isLoading } = useQuery<PartnerQueueRow[]>({
    queryKey: ['partner-queue', form?.id],
    queryFn: () => partnersApi.getQueue(form!.id),
    enabled: form != null,
  });

  return { formId: form?.id, queue, isLoading: isLoading || form === undefined };
}
